/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Product Recall API
 * API pour la gestion des rappels de produits défectueux
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type { CreateInspectionDto, SimondQuickdraw } from './models'

import { customInstance } from '../mutators/axios-instance'
export const appControllerGetHello = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/`, method: 'GET', signal })
}

export const getAppControllerGetHelloQueryKey = () => {
  return [`/`] as const
}

export const getAppControllerGetHelloQueryOptions = <
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAppControllerGetHelloQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerGetHello>>> = ({ signal }) =>
    appControllerGetHello(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof appControllerGetHello>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppControllerGetHelloQueryResult = NonNullable<
  Awaited<ReturnType<typeof appControllerGetHello>>
>
export type AppControllerGetHelloQueryError = unknown

export function useAppControllerGetHello<
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appControllerGetHello>>,
          TError,
          Awaited<ReturnType<typeof appControllerGetHello>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppControllerGetHello<
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appControllerGetHello>>,
          TError,
          Awaited<ReturnType<typeof appControllerGetHello>>
        >,
        'initialData'
      >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppControllerGetHello<
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAppControllerGetHello<
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>
    >
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAppControllerGetHelloQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Stores the anonymous outcome of the wire gate check together with the locale it was read in. No personal data is collected: the safety information is never gated behind a form and the refund is handled in store. One record is one reader's overall verdict, not one carabiner.
 * @summary Record a self-reported quickdraw inspection
 */
export const simondQuickdrawControllerCreateInspection = (
  createInspectionDto: CreateInspectionDto,
  signal?: AbortSignal,
) => {
  return customInstance<SimondQuickdraw>({
    url: `/simond-quickdraw/inspection`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createInspectionDto,
    signal,
  })
}

export const getSimondQuickdrawControllerCreateInspectionMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simondQuickdrawControllerCreateInspection>>,
    TError,
    { data: CreateInspectionDto },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof simondQuickdrawControllerCreateInspection>>,
  TError,
  { data: CreateInspectionDto },
  TContext
> => {
  const mutationKey = ['simondQuickdrawControllerCreateInspection']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof simondQuickdrawControllerCreateInspection>>,
    { data: CreateInspectionDto }
  > = props => {
    const { data } = props ?? {}

    return simondQuickdrawControllerCreateInspection(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type SimondQuickdrawControllerCreateInspectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof simondQuickdrawControllerCreateInspection>>
>
export type SimondQuickdrawControllerCreateInspectionMutationBody = CreateInspectionDto
export type SimondQuickdrawControllerCreateInspectionMutationError = void

/**
 * @summary Record a self-reported quickdraw inspection
 */
export const useSimondQuickdrawControllerCreateInspection = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof simondQuickdrawControllerCreateInspection>>,
      TError,
      { data: CreateInspectionDto },
      TContext
    >
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof simondQuickdrawControllerCreateInspection>>,
  TError,
  { data: CreateInspectionDto },
  TContext
> => {
  const mutationOptions = getSimondQuickdrawControllerCreateInspectionMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
